import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * QuotaRetractionView class extends JetView to create a form for quota retraction.
 */
export default class QuotaRetractionView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with a dropdown for selecting the type of balance
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect',
                    name: 'Type', // Field name for the type of balance
                    label: _('Tipo de Saldo'), // Label for the dropdown
                    labelPosition: 'top',
                    options: [
                        { id: '0', value: _('Saldo de Recargas') }, // Option for recharge balance
                        { id: '1', value: _('Saldo de Juego') }, // Option for game balance
                    ],
                    required: true, // Field is required
                },
            ],
        };

        // Center left section for entering the amount
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'Amount', // Field name for the amount
                    label: _('Valor'), // Label for the amount input
                    labelPosition: 'top',
                    required: true, // Field is required
                },
            ],
        };

        // Center right section for confirming the amount
        const center_right = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'AmountConfirm', // Field name for confirming the amount
                    label: _('Confirmar Valor'), // Label for the confirmation input
                    labelPosition: 'top',
                    required: true, // Field is required
                },
            ],
        };

        const right = {
            margin: 5,
            rows: [], // Placeholder for future elements
        };

        // Upper section layout combining left, center left, center right, and right sections
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_right,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button section with a submit button for retraction
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Retraer'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event handler for the button
                        if ($$('quotaRetraction').validate()) {
                            // Validate the form
                            const newRecarga = this.getRoot().getValues(); // Get form values
                            const cur_user = this.getParam('user', true); // Get current user parameter
                            var vthis = this; // Reference to the current instance

                            // Check if the amounts match
                            if (newRecarga.Amount === newRecarga.AmountConfirm) {
                                webix.confirm({
                                    // Confirmation dialog
                                    type: 'confirm-warning',
                                    text:
                                        _('Advertencia!') + '<br/>' + _('Confirme retracción de ') + newRecarga.Amount,
                                    ok: _('Retraer'),
                                    cancel: _('Salir'),
                                    callback: function (action) {
                                        // Callback for confirmation action
                                        if (action === true) {
                                            const data = {
                                                Type: newRecarga.Type,
                                                Amount: newRecarga.Amount,
                                                AmountConfirm: newRecarga.AmountConfirm,
                                            }; // Data to be sent in the request

                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Agent/MakeQuotaRetraction', // API endpoint
                                                    data,
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handler
                                                            webix.message(_('¡Error!')); // Show error message
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            // Success handler
                                                            var json = JSON.parse(text); // Parse response
                                                            if (json.HasError) {
                                                                // Check for errors in response
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _(
                                                                        'Ocurrio un error, comuniquese con soporte',
                                                                    ), // Error message
                                                                });
                                                            } else {
                                                                webix.message(_('Solicitud de Retracción Enviada')); // Success message
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                });
                            } else {
                                webix.message({
                                    // Show error if amounts do not match
                                    title: _('¡Error!'),
                                    type: 'alert-error',
                                    text: _('Los montos no coinciden'),
                                });
                            }
                        } else {
                            webix.message({
                                // Show error if form is not valid
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: _('Completa los campos...'),
                            });
                        }
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'quotaRetraction', // Unique identifier for the form
            rows: [upper_section, buttons], // Combine upper section and buttons
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        this.on(this.app, 'agentForm:data', (premio) => {
            // Event listener for data from agent form
            form.setValues(premio); // Set form values with received data
            console.log('premio', premio); // Log the received data
        });
    }
}

// FILE DOCUMENTED
